<ng-template #createButton>
  <button test-id="create-button" mat-flat-button color="primary" (click)="editProtocol()">{{ 'viewerProtocols.protocolList.createButton' | translate }}</button>
</ng-template>

<mat-card appearance="outlined" [class.full-height]="unfilteredProtocolsExist">
  <mat-card-title *ngIf="unfilteredProtocolsExist || isLoading">
    <div>
      <label>{{ 'viewerProtocols.protocolList.viewerProtocols' | translate }}</label>
      <p class="text-muted">{{ 'viewerProtocols.protocolList.subheader' | translate }}</p>
    </div>
    <div>
      <ng-container *ngTemplateOutlet="createButton"></ng-container>
    </div>
  </mat-card-title>

  <mat-card-content *ngIf="isLoading && !unfilteredProtocolsExist">
    <mat-progress-bar mode="buffer"></mat-progress-bar>
  </mat-card-content>

  <mat-card-content class="empty" *ngIf="!isLoading && !unfilteredProtocolsExist">
    <ng-container *ngTemplateOutlet="empty"></ng-container>
  </mat-card-content>

  <mat-card-content [class.hidden]="!unfilteredProtocolsExist">
    <div class="table-wrapper">
      <table mat-table matSort matSortDisableClear [dataSource]="protocols$" [matSortActive]="protocolSort$.value.active"
        [matSortDirection]="protocolSort$.value.direction" (matSortChange)="protocolSort$.next($event)">

        <ng-container matColumnDef="label">
          <th mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="outline">
              <input test-id="protocol-label-filter" type="text" matInput [formControl]="$any(filters.get('label'))"
                placeholder="{{ 'viewerProtocols.protocolList.table.protocol' | translate }}" autocomplete="off"
                (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
              <button *ngIf="filters.get('label').value"
                test-id="label-filter-clear" matSuffix mat-icon-button (click)="filters.get('label').reset()"
                matTooltip="{{ 'common.labels.clearTooltip' | translate }}" matTooltipPosition="right">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.label }}
          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>{{ 'viewerProtocols.protocolList.table.description' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <fw-ellipsis [text]="element?.description || ''"></fw-ellipsis>
          </td>
        </ng-container>

        <ng-container matColumnDef="creator">
          <th mat-header-cell *matHeaderCellDef>
            <app-typeahead test-id="creator-filter" [options]="userOptions"
              placeholder="{{ 'viewerProtocols.protocolList.table.creator' | translate }}" [(value)]="creatorFilter"
              (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
            </app-typeahead>
          </th>
          <td mat-cell *matCellDef="let element" [matTooltip]="element.creator?._id">
            <div class="flex-wrapper">
              <app-avatar [users]="element.creator" [enablePopover]="false" [enableAnimation]="true"></app-avatar>
              <span class="ellipsis-block">
                {{ element.creator?.firstname }} {{ element.creator?.lastname }}
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="modified">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'viewerProtocols.protocolList.table.lastModified' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.lastModifiedDisplay }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; let i = index;" class="text-right list-action-buttons">
            <div class="list-action-buttons">
              <button mat-icon-button [matMenuTriggerFor]="actionMenu" [attr.test-id]="'actions-trigger-' + i">
                <mat-icon class="meatballs xs" [ngClass]="{ 'disabled': !canModify }" iconPositionEnd>more_vert</mat-icon>
              </button>
              <mat-menu #actionMenu="matMenu" xPosition="before">
                <button mat-menu-item [attr.test-id]="'edit-action-' + i" (click)="$event.stopPropagation(); editProtocol(element)">
                  <fw-icon class="action-icon sm">edit</fw-icon>
                  {{ 'common.actions.edit' | translate }}
                </button>
                <button mat-menu-item [attr.test-id]="'duplicate-action-' + i" (click)="$event.stopPropagation(); duplicateProtocol(element)">
                  <fw-icon class="action-icon sm">apply-copy-duplicate</fw-icon>
                  {{ 'common.actions.duplicate' | translate }}
                </button>
                <button mat-menu-item [attr.test-id]="'delete-action-' + i" (click)="$event.stopPropagation(); deleteProtocol(element)">
                  <fw-icon class="action-icon sm red">trash-delete</fw-icon>
                  {{ 'common.actions.delete' | translate }}
                </button>
              </mat-menu>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns; sticky: true "></tr>
        <tr mat-row *matRowDef="let row; columns: columns;" class="list-action-hover"></tr>

      </table>
      <div #fwLoadTrigger (fwLoadTrigger)="loadMore()" class="load-trigger"></div>

      <fw-loading *ngIf="isLoading && unfilteredProtocolsExist"></fw-loading>

      <div *ngIf="!isLoading && !hasProtocols && !hasLoadingError && hasFilters">
        <ng-container *ngTemplateOutlet="empty"></ng-container>
      </div>

      <div *ngIf="hasLoadingError" class="empty blank-state">
        <mat-icon class="sm raised red">priority_high</mat-icon>
        <p>{{ 'protocols.content.loadingError' | translate }}</p>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<ng-template #empty>
  <div class="empty empty-inside">
    <fw-icon>settings-gear-square</fw-icon>
    <p>{{ 'viewerProtocols.protocolList.empty.title' | translate }}</p>
    <small class="body text-muted">{{ 'viewerProtocols.protocolList.empty.body' | translate }}</small>
    <small>
      <span class="text-muted">{{ 'viewerProtocols.protocolList.empty.viewDocsHint' | translate }} </span>
      <a href="https://docs.flywheel.io/?q=creating+viewer+protocol" target="_blank">{{ 'viewerProtocols.protocolList.empty.viewDocs' | translate }}</a>
    </small>
    <ng-container *ngIf="!unfilteredProtocolsExist">
      <ng-container *ngTemplateOutlet="createButton"></ng-container>
    </ng-container>
  </div>
</ng-template>
